import React, { useState } from 'react';
import SingleDocumentModal from '~/routes/document_grid_view/grid_table/singleDocumentModal';
const SingleItem = (props) => {
    const { clause, documents, classificationName, anchorClauses, comparatorClauses, isToggled, onClickClauseSection, } = props;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => setIsModalVisible(true);
    const hideModal = () => setIsModalVisible(false);
    const anchorDoc = documents === null || documents === void 0 ? void 0 : documents[0];
    const doc = documents === null || documents === void 0 ? void 0 : documents[1];
    const tabs = doc === null || doc === void 0 ? void 0 : doc.classificationMap.get(classificationName);
    const anchorClassification = anchorDoc === null || anchorDoc === void 0 ? void 0 : anchorDoc.classificationMap.get(classificationName);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `accordion-clause-item single ${isToggled ? 'selected' : ''}`, onClick: onClickClauseSection },
            React.createElement("div", { className: 'accordion-clause-item-category' }, clause.categoryTag.displayName),
            isToggled &&
                React.createElement("div", { className: 'expand-icon', onClick: showModal, title: 'Expand Clauses' },
                    React.createElement("i", { className: 'fas fa-expand-arrows-alt' }))),
        React.createElement("div", { className: 'unexpanded-name' },
            React.createElement("div", { className: 'overflow-ellipsis' }, clause.descriptorTag.displayName),
            React.createElement("span", { className: 'icons' },
                comparatorClauses.length > 0 &&
                    React.createElement("span", null,
                        React.createElement("i", { className: 'fas fa-file' })),
                anchorClauses.length > 0 &&
                    React.createElement("span", null,
                        React.createElement("i", { className: 'fas fa-star' })))),
        isModalVisible && React.createElement(SingleDocumentModal, { anchorDoc: anchorDoc, disableComments: true, anchorClassification: anchorClassification, classification: doc, onHide: hideModal, visible: isModalVisible, comparisonDoc: doc, tabs: tabs })));
};
export default SingleItem;
